import type { Dispatch } from 'redux'
import { connect } from 'react-redux'
import { ResetPasswordComponent } from './ResetPasswordComponent'
import type { RootState } from 'shared/store/reducers'
import { getUrlParams, resetPassword } from 'shared/store/reset-password'
import { push } from 'connected-react-router'

const mapStateToProps = (state: RootState) => {
    const { resetPasswordPageState, router } = state
    const { authenticationIsFromUrl } = router.location.state || {}
    return {
        ...resetPasswordPageState,
        authenticationIsFromUrl: authenticationIsFromUrl
    }
}

const mapDispatchToProps = (d: Dispatch<any>) => ({
    // sendMeta: (meta: EventMetadata) => d(eventMetadata(meta)),
    getUrlParams: () => d(getUrlParams()),
    resetPassword: () => d(resetPassword()),
    navigate: (to: string, state?: any) =>
        d(
            push({
                pathname: to,
                state
            })
        )
})

const ResetPassword = connect(
    mapStateToProps,
    mapDispatchToProps
)(ResetPasswordComponent)

export { ResetPassword }
